// Bilingual content for TRANSAFRICA CANADA

export const content = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      services: 'Services',
      destinations: 'Destinations',
      pricing: 'Tarifs',
      contact: 'Contact',
      getQuote: 'Demander un devis'
    },
    splash: {
      welcome: 'Bienvenue chez',
      company: 'TRANSAFRICA CANADA',
      tagline: 'Votre pont logistique entre le Canada et l\'Afrique',
      selectLanguage: 'Choisissez votre langue',
      french: 'Français',
      english: 'English'
    },
    hero: {
      subtitle: 'Logistique internationale',
      title: 'Connecter le Canada et l\'Afrique',
      description: 'Service de livraison express international, fiable, rapide et sécurisé. Inspiré des standards DHL avec une touche d\'innovation et de proximité.',
      cta1: 'Demander un devis',
      cta2: 'Nos services'
    },
    services: {
      subtitle: 'Nos Services',
      title: 'Solutions logistiques complètes',
      description: 'Nous offrons une gamme complète de services pour répondre à tous vos besoins de transport et de logistique.',
      items: [
        {
          icon: 'Plane',
          title: 'Livraison express internationale',
          description: 'Expédition rapide entre le Canada et l\'Afrique en 3 à 7 jours.'
        },
        {
          icon: 'Truck',
          title: 'Livraison nationale',
          description: 'Service de livraison locale dans chaque pays de notre réseau.'
        },
        {
          icon: 'Ship',
          title: 'Fret aérien et maritime',
          description: 'Solutions de fret pour vos envois volumineux ou commerciaux.'
        },
        {
          icon: 'FileCheck',
          title: 'Service import-export',
          description: 'Accompagnement complet pour vos opérations commerciales.'
        },
        {
          icon: 'Shield',
          title: 'Assistance douanière',
          description: 'Expertise pour le dédouanement de vos marchandises.'
        },
        {
          icon: 'Home',
          title: 'Livraison à domicile',
          description: 'Livraison directe chez vous ou à notre agence partenaire.'
        }
      ]
    },
    about: {
      subtitle: 'À Propos',
      title: 'Qui sommes-nous?',
      description: 'TRANS AFRICA CANADA est une agence de logistique internationale, de transport express et de courrier. Nous sommes une agence moderne internationale, respectant les standards DHL, fiable, rapide et sécurisée, équipée d\'un réseau de véhicules et d\'équipes dans chaque pays.',
      mission: {
        title: 'Notre Mission',
        text: 'Connecter les continents, faciliter les échanges et sécuriser les envois.'
      },
      vision: {
        title: 'Notre Vision',
        text: 'Devenir l\'un des leaders panafricains et canadiens de la logistique moderne.'
      },
      values: {
        title: 'Nos Valeurs',
        items: ['Fiabilité', 'Rapidité', 'Sécurité', 'Innovation', 'Respect', 'Transparence']
      },
      foundersMessage: '"TRANS AFRICA CANADA n\'est pas juste une entreprise de logistique. C\'est un réseau qui unit les peuples, soutient les familles, accompagne les entrepreneurs et crée un pont solide entre le Canada et l\'Afrique."'
    },
    destinations: {
      subtitle: 'Notre Réseau',
      title: 'Présence Internationale',
      description: 'Un réseau étendu pour vous servir au Canada et en Afrique.',
      locations: [
        { country: 'Canada', cities: ['Ottawa (Siège social)'], flag: '🇨🇦' },
        { country: 'Sénégal', cities: ['Dakar'], flag: '🇸🇳' },
        { country: 'Cameroun', cities: ['Douala', 'Yaoundé'], flag: '🇨🇲' },
        { country: 'RD Congo', cities: ['Kinshasa', 'Lubumbashi'], flag: '🇨🇩' },
        { country: 'Congo', cities: ['Brazzaville', 'Pointe-Noire'], flag: '🇨🇬' }
      ]
    },
    pricing: {
      subtitle: 'Nos Tarifs',
      title: 'Prix compétitifs',
      description: 'Des tarifs transparents pour tous vos envois.',
      routes: [
        {
          title: 'Canada → Afrique',
          price: '18$ - 40$',
          unit: 'par kg',
          features: ['Livraison en 3-7 jours', 'Suivi en temps réel', 'Assurance incluse']
        },
        {
          title: 'Afrique → Canada',
          price: '30$ - 35$',
          unit: 'par kg',
          features: ['Livraison en 4-10 jours', 'Ramassage à domicile', 'Assistance douanière']
        },
        {
          title: 'Livraison locale',
          price: '24 - 72h',
          unit: 'délai',
          features: ['Dans chaque pays', 'Prix selon distance', 'Livraison express']
        }
      ],
      note: 'Les prix varient selon le poids, le volume et la destination. Contactez-nous pour un devis personnalisé.'
    },
    contact: {
      subtitle: 'Contact',
      title: 'Contactez-nous',
      description: 'Notre équipe est disponible pour répondre à toutes vos questions.',
      form: {
        name: 'Nom complet',
        email: 'Adresse email',
        phone: 'Téléphone',
        subject: 'Sujet',
        message: 'Votre message',
        submit: 'Envoyer le message',
        success: 'Message envoyé avec succès!'
      },
      info: {
        address: '3-425 McArthur Avenue, Ottawa, Ontario, Canada',
        email: 'info@transafricacanada.com',
        phone: '+1 (613) 000-0000',
        hours: 'Lun - Ven: 9h00 - 18h00'
      }
    },
    footer: {
      description: 'TRANS AFRICA CANADA - Votre partenaire logistique de confiance entre le Canada et l\'Afrique.',
      quickLinks: 'Liens rapides',
      contactInfo: 'Contact',
      followUs: 'Suivez-nous',
      rights: '© 2025 TRANS AFRICA CANADA. Tous droits réservés.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      destinations: 'Destinations',
      pricing: 'Pricing',
      contact: 'Contact',
      getQuote: 'Get a Quote'
    },
    splash: {
      welcome: 'Welcome to',
      company: 'TRANSAFRICA CANADA',
      tagline: 'Your logistics bridge between Canada and Africa',
      selectLanguage: 'Choose your language',
      french: 'Français',
      english: 'English'
    },
    hero: {
      subtitle: 'International Logistics',
      title: 'Connecting Canada and Africa',
      description: 'Reliable, fast, and secure international express delivery service. Inspired by DHL standards with a touch of innovation and proximity.',
      cta1: 'Get a Quote',
      cta2: 'Our Services'
    },
    services: {
      subtitle: 'Our Services',
      title: 'Complete Logistics Solutions',
      description: 'We offer a full range of services to meet all your transportation and logistics needs.',
      items: [
        {
          icon: 'Plane',
          title: 'International Express Delivery',
          description: 'Fast shipping between Canada and Africa in 3 to 7 days.'
        },
        {
          icon: 'Truck',
          title: 'National Delivery',
          description: 'Local delivery service in each country of our network.'
        },
        {
          icon: 'Ship',
          title: 'Air and Sea Freight',
          description: 'Freight solutions for your bulky or commercial shipments.'
        },
        {
          icon: 'FileCheck',
          title: 'Import-Export Service',
          description: 'Complete support for your commercial operations.'
        },
        {
          icon: 'Shield',
          title: 'Customs Assistance',
          description: 'Expertise in customs clearance for your goods.'
        },
        {
          icon: 'Home',
          title: 'Home Delivery',
          description: 'Direct delivery to your home or our partner agency.'
        }
      ]
    },
    about: {
      subtitle: 'About Us',
      title: 'Who We Are',
      description: 'TRANS AFRICA CANADA is an international logistics, express transport, and courier agency. We are a modern international agency, respecting DHL standards, reliable, fast, and secure, equipped with a network of vehicles and teams in each country.',
      mission: {
        title: 'Our Mission',
        text: 'To connect continents, facilitate exchanges, and secure shipments.'
      },
      vision: {
        title: 'Our Vision',
        text: 'To become one of the pan-African and Canadian leaders in modern logistics.'
      },
      values: {
        title: 'Our Values',
        items: ['Reliability', 'Speed', 'Security', 'Innovation', 'Respect', 'Transparency']
      },
      foundersMessage: '"TRANS AFRICA CANADA is not just a logistics company. It is a network that unites peoples, supports families, accompanies entrepreneurs, and creates a solid bridge between Canada and Africa."'
    },
    destinations: {
      subtitle: 'Our Network',
      title: 'International Presence',
      description: 'An extensive network to serve you in Canada and Africa.',
      locations: [
        { country: 'Canada', cities: ['Ottawa (Headquarters)'], flag: '🇨🇦' },
        { country: 'Senegal', cities: ['Dakar'], flag: '🇸🇳' },
        { country: 'Cameroon', cities: ['Douala', 'Yaoundé'], flag: '🇨🇲' },
        { country: 'DR Congo', cities: ['Kinshasa', 'Lubumbashi'], flag: '🇨🇩' },
        { country: 'Congo', cities: ['Brazzaville', 'Pointe-Noire'], flag: '🇨🇬' }
      ]
    },
    pricing: {
      subtitle: 'Our Rates',
      title: 'Competitive Pricing',
      description: 'Transparent pricing for all your shipments.',
      routes: [
        {
          title: 'Canada → Africa',
          price: '$18 - $40',
          unit: 'per kg',
          features: ['Delivery in 3-7 days', 'Real-time tracking', 'Insurance included']
        },
        {
          title: 'Africa → Canada',
          price: '$30 - $35',
          unit: 'per kg',
          features: ['Delivery in 4-10 days', 'Home pickup', 'Customs assistance']
        },
        {
          title: 'Local Delivery',
          price: '24 - 72h',
          unit: 'timeframe',
          features: ['In each country', 'Price by distance', 'Express delivery']
        }
      ],
      note: 'Prices vary based on weight, volume, and destination. Contact us for a personalized quote.'
    },
    contact: {
      subtitle: 'Contact',
      title: 'Get in Touch',
      description: 'Our team is available to answer all your questions.',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Your Message',
        submit: 'Send Message',
        success: 'Message sent successfully!'
      },
      info: {
        address: '3-425 McArthur Avenue, Ottawa, Ontario, Canada',
        email: 'info@transafricacanada.com',
        phone: '+1 (613) 000-0000',
        hours: 'Mon - Fri: 9:00 AM - 6:00 PM'
      }
    },
    footer: {
      description: 'TRANS AFRICA CANADA - Your trusted logistics partner between Canada and Africa.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact',
      followUs: 'Follow Us',
      rights: '© 2025 TRANS AFRICA CANADA. All rights reserved.'
    }
  }
};

export const logoUrl = 'https://customer-assets.emergentagent.com/job_375fdc7f-5587-40f0-a8e2-719ee900cdfe/artifacts/hox1av7q_IMG-20251217-WA0007.jpg';
